import AppHelp from "./pages/AppHelp";
import Test from "./pages/test";
import userProfile from "./pages/userProfile";
import InspectionPreContact from "./pages/InspectionPreContact";
import InactiveInspections from "./pages/InactiveInspections";
import MapTesting from "./pages/MapTesting";
import InspectorInvoicePrices from "./pages/InspectorInvoicePrices";
import SoftwareInvoicePrices from "./pages/SoftwareInvoicePrices";
import InspectionPrices from "./pages/InspectionPrices";
import Invoices from "./pages/Invoices";
import MissingPhotos from "./pages/MissingPhotos";
import InspectionSupplements from "./pages/InspectionSupplements";
import IncomingInspections from "./pages/IncomingInspections";
import SoftwareInvoices from "./pages/SoftwareInvoices";
import InspectorInvoices from "./pages/InspectorInvoices";
import InspectorInvoiceExtraCosts from "./pages/InspectorInvoiceExtraCosts";
import MyBilling from "./pages/MyBilling";
import AreaMap from "./pages/AreaMap";
import AreaMapInspectors from "./pages/AreaMapInspectors";
import InspectionTime from "./pages/InspectionTime";
import InspectionTimingDashboard from "./pages/InspectionTimingDashboard";
import LateReport from "./pages/LateReport";
import InspectionTimeCreated from "./pages/InspectionTimeCreated";
import LateReportList from "./pages/LateReportList";
import PolicyListStatus from "./pages/PolicyListStatus";
import Planner from "./pages/Planner";
import LateDash from "./pages/LateDash";
import OrchidOpenList from "./pages/OrchidOpenList";
import HeatMap from "./pages/HeatMap";
import OpenMap from "./pages/OpenMap";
import InspectorAvailability from "./pages/InspectorAvailability";
import WorkAreas from "./pages/WorkAreas";
import InspectorCountyMapping from "./pages/InspectorCountyMapping";
import PolicyListStatusUniversal from "./pages/PolicyListStatusUniversal";
import FolderManagement from "./pages/FolderManagement";
import CRCManualOrder from "./pages/CRCManualOrder";
import TrackingDashboard from "./pages/TrackingDashboard";
import SupportDashboard from "./pages/SupportDashboard";
import QAReview from "./pages/QAReview";
import OrchidFeedback from "./pages/OrchidFeedback";
import { FormDistributionQuestion, FormRoofGeometryQuestion } from "./components/form-questions";
import SchedulerOverview from "./pages/SchedulerOverview";
import AutoScheduleConfig from "./pages/AutoScheduleConfig";
import EntitlementsAdmin from "./pages/EntitlementsAdmin";
import AutoSchedulePredictions from "./pages/AutoSchedulePredictions";
import SchedulerCalendar from "./pages/SchedulerCalendar";
import SchedulerHeaderPrototype from "./components/SchedulerHeaderPrototype";

// Add root components to this list so that they can be loaded dynamically
const COMPONENTS = {
  AppHelp,
  Test,
  userProfile,
  InspectionPreContact,
  InactiveInspections,
  InspectionPrices,
  InspectorInvoicePrices,
  SoftwareInvoicePrices,
  Invoices,
  InspectionSupplements,
  MissingPhotos,
  IncomingInspections,
  SoftwareInvoices,
  InspectorInvoices,
  InspectorInvoiceExtraCosts,
  MyBilling,
  MapTesting,
  AreaMap,
  AreaMapInspectors,
  InspectionTime,
  InspectionTimingDashboard,
  LateReport,
  InspectionTimeCreated,
  LateReportList,
  PolicyListStatus,
  LateDash,
  Planner,
  OrchidOpenList,
  HeatMap,
  OpenMap,
  InspectorAvailability,
  WorkAreas,
  InspectorCountyMapping,
  PolicyListStatusUniversal,
  FolderManagement,
  CRCManualOrder,
  TrackingDashboard,
  SupportDashboard,
  QAReview,
  OrchidFeedback,
  FormDistributionQuestion,
  FormRoofGeometryQuestion,
  SchedulerOverview,
  SchedulerCalendar,
  SchedulerHeaderPrototype,
  EntitlementsAdmin,
  AutoSchedulePredictions,
  AutoScheduleConfig
};

export default COMPONENTS;
